import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(advancedFormat)
dayjs.extend(timezone)
dayjs.extend(utc)

export default defineNuxtPlugin(() => ({
  provide: { dayjs },
}))
